module.exports = __webpack_public_path__ + "static/02-802a15645d8d224d93a9e19deedc92ee.jpg";